import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal as BaseModal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';

export interface ModalProps {
  isOpen: boolean;
  message?: string;
  onCancel?: () => void;
  onSuccess?: () => void;
  title?: string;
  successLabel?: string;
  variant?: 'warning' | 'error';
}

export const Modal: React.FunctionComponent<ModalProps> = ({
  isOpen,
  message,
  onCancel,
  onSuccess,
  successLabel,
  title,
  variant,
}) => {
  return (
    <BaseModal isOpen={isOpen} size="medium" onRequestClose={onCancel}>
      <ModalHeader variant={variant}>{title}</ModalHeader>
      <ModalCloseButton onClick={onCancel} />

      <ModalBody>{message}</ModalBody>

      <ModalFooter>
        <Box display="flex" justifyContent="flex-end">
          <Button variant="subtleInactive" onClick={onCancel}>
            Cancel
          </Button>
          <Button ml="12" onClick={onSuccess}>
            {successLabel}
          </Button>
        </Box>
      </ModalFooter>
    </BaseModal>
  );
};
